// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"501":"d13bf505216111a2","4316":"da7517a88118b074","6457":"2836474f9bc0af5c","9839":"12c9392b4199081f"}[chunkId] + ".js";
};